export default __webpack_public_path__ + "static/media/dark-knight-system.bc9e8ec3.webp";